var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFhoPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.108,
    height: 71.633,
    viewBox: "0 0 54.108 71.633",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_4421",
    x: 0,
    y: 0,
    width: 54.108,
    height: 71.633,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4809",
    "data-name": "Group 4809",
    transform: "translate(17632 14683.634)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029",
    transform: "translate(-17623 -14677.634)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    cx: 13.721,
    cy: 13.721,
    r: 13.721,
    transform: "translate(4.364 4.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Path_4421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4421-2",
    "data-name": "Path 4421",
    d: "M18.054,0A18.054,18.054,0,0,0,0,18.054c0,9.971,18.054,35.579,18.054,35.579S36.108,28.025,36.108,18.054A18.054,18.054,0,0,0,18.054,0m0,30.965A12.911,12.911,0,1,1,30.965,18.054,12.911,12.911,0,0,1,18.054,30.965",
    transform: "translate(9 6)",
    fill: "#0d47a1"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "building-user",
    transform: "translate(-17612.602 -14666.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4504",
    "data-name": "Path 4504",
    d: "M355.445,195.828a1.914,1.914,0,1,0-1.914-1.914A1.914,1.914,0,0,0,355.445,195.828Zm-1.218.766A2.228,2.228,0,0,0,352,198.82a.834.834,0,0,0,.835.835h5.22a.834.834,0,0,0,.835-.835,2.228,2.228,0,0,0-2.227-2.227Z",
    transform: "translate(-343.579 -187.407)",
    fill: "#888",
    opacity: 0.803
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4505",
    "data-name": "Path 4505",
    d: "M0,1.148A1.149,1.149,0,0,1,1.148,0h6.89A1.149,1.149,0,0,1,9.186,1.148V8.8a2.991,2.991,0,0,0-1.531,2.612,1.591,1.591,0,0,0,.237.84H5.741V10.335a1.148,1.148,0,1,0-2.3,0v1.914h-2.3A1.149,1.149,0,0,1,0,11.1Zm1.914,4.21a.384.384,0,0,0-.383.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V5.741a.384.384,0,0,0-.383-.383Zm1.914.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V5.741a.384.384,0,0,0-.383-.383H4.21A.384.384,0,0,0,3.828,5.741Zm2.679-.383a.384.384,0,0,0-.383.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V5.741a.384.384,0,0,0-.383-.383ZM1.531,2.679v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V2.679A.384.384,0,0,0,2.679,2.3H1.914A.384.384,0,0,0,1.531,2.679ZM4.21,2.3a.384.384,0,0,0-.383.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V2.679A.384.384,0,0,0,4.976,2.3Zm1.914.383v.766a.384.384,0,0,0,.383.383h.766a.384.384,0,0,0,.383-.383V2.679A.384.384,0,0,0,7.273,2.3H6.507A.384.384,0,0,0,6.124,2.679Z",
    fill: "#0d47a1"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFhoPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FHO-pin.ac4eeb46270f1ba64a9b695d64655306.svg";